import React from "react";
import Layout from "../layouts/layout";
import Index from "../components/summary";

export default function Summary(){
  return(
    <>
    <Layout>
      <Index />
    </Layout>
    </>
  )
}